import script from "./SecondScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondScreen.vue?vue&type=script&setup=true&lang=js"

import "./SecondScreen.vue?vue&type=style&index=0&id=1511d1db&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1511d1db"]])

export default __exports__